import { plugin, Mode } from 'light-component';
import { type ReactElement } from 'react';
import { useTranslation } from '../../../i18n';
import { WidgetType } from '../types';
import { Thumbnail } from '../../component';
import { ShotEyesImageInputMode } from './input';
import { ShotEyesImageDesignMode } from './design';
import { ShotEyesImageViewMode } from './view';
import type { ShotEyesImageProps } from './types';

export function Image(props: ShotEyesImageProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='ShotEyesImageIcon' title={t('ShotEyesImage')} toolTipContent={t('上传若干图片')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<ShotEyesImageDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<ShotEyesImageViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<ShotEyesImageInputMode {...props} />);
  }

  return null;
}

Image.prototype.type = WidgetType.SHOTEYES_IMAGE;
plugin.register({ kind: 'widget', component: Image });
